import 'jquery-pimcore-formbuilder/dist/jquery.fb.ext.repeater';

document.addEventListener('DOMContentLoaded', () => {
    $('form.formbuilder').formBuilderRepeater({
        classes: {
            add: 'btn btn-primary mt-2 fs-8',
            remove: 'btn btn-danger w-auto ms-auto mt-2 float-end fs-8'
        }
    });
});